import { connect } from 'react-redux';
import ResendEmail from './ResendEmail';
import { forgotPasswordRequest, resetErrorMesage } from '../../../store/actions/auth.actions';
import { logo } from '../../../store/selectors/auth.selector';

const mapDispatchToProps = { forgotPasswordRequest, resetErrorMesage };

const mapStateToProps = (state) => { 
    const getLogo = logo(state);

    return { getLogo };
 };

export default connect(mapStateToProps, mapDispatchToProps)(ResendEmail);